import React from 'react';

interface HeroSectionProps {
  title: string;
  subtitle: string;
  className?: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({ title, subtitle, className = '' }) => {
  return (
    <section className={`hero-section ${className}`}>
      <div className="container">
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>
    </section>
  );
};

export default HeroSection;
